<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateFarm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillFertilizerForm="fillFertilizerForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('samples.nutrients')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillFertilizerForm="fillFertilizerForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ fertilizerForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ fertilizerForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('labor.unit_of_measure') }}:</strong>
                        </h6>
                        {{ fertilizerForm.unit_measure }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.value') }}:</strong>
                        </h6>
                        ${{ fertilizerForm.value }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.conversion_factor') }}:</strong
                          >
                        </h6>
                        {{ fertilizerForm.conversion_factor }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.nutrients') }}:</strong>
                        </h6>
                        <br />
                        <ul
                          v-for="(option, index) in fertilizerForm.nutrients"
                          :key="index"
                        >
                          <li>
                            {{ $t('samples.nutrient') }}:
                            {{ nutriens_names[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.percentage') }} (%):
                            {{ fertilizerForm.percentages[index] }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
  },

  data() {
    return {
      fertilizerForm: {},
      nutriens_names: [],
      all_nutrients: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinMenu],

  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {
        nutrients: [],
        percentages: [],
        fertilizer_nutrients_ids: [],
        fertilizer_nutrients_ids_bck: [],
      };
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillFertilizerForm(ref) {
      this.fertilizerForm = Object.assign(
        {},
        this.fertilizerForm,
        this.$refs[ref].model
      );
      this.nutriens_names = [];

      if (ref == 'secondStep') {
        this.fertilizerForm.nutrients.forEach((elem) => {
          let index = this.all_nutrients.findIndex(
            (tableRow) => tableRow.id === elem
          );
          this.nutriens_names.push(
            this.all_nutrients[index].symbol +
              ' - ' +
              this.all_nutrients[index].description
          );
        });
      }
    },

    storeUpdateFarm() {
      this.showHideLoading(true);
      this.fertilizerForm.route = 'fertilization/fertilizers';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.fertilizerForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;

          Axios.updateMaster(this.fertilizerForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/fertilizers',
                'fertilizerForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.fertilizerForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/fertilizers',
                'fertilizerForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    Axios.getMasters('fertilization/nutrients')
      .then((response) => {
        this.all_nutrients = response.data.data;
        this.showHideLoading();
      })
      .catch((error) => this.showMessageErrors(error));
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
